import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { selectHasPermission } from 'app/reducers/context.selectors';
import { Observable, of } from 'rxjs';

/**
 * Гард маршрута по праву новой ролевой системы (IC-2972). Требуемый код права
 * передаётся через `data: { permission: <HubPermissionCode> }`. Сисадмин проходит
 * всегда (учтено в selectHasPermission). Пришёл на смену ролевым гардам
 * (ManagerGuard/AdminGuard), которые не видели прав новой системы.
 */
@Injectable()
export class PermissionGuard implements CanActivate {
  constructor(private store: Store) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const permission = route.data?.['permission'] as number | undefined;
    if (permission == null) {
      return of(true);
    }

    return this.store.select(selectHasPermission(permission));
  }
}
